import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// Auth Services
import { AuthenticationService } from '../services/auth.service';
import { AuthfakeauthenticationService } from '../services/authfake.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private authFackservice: AuthfakeauthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    const currentUser = this.authFackservice.currentUserValue;
    if (currentUser) return true;

    // Attempt token-based login
    return this.authenticationService.autoLoginViaTokenAPI()
        .then(success => {
            if (success) {
            // Redirect only if trying to access login page
            if (state.url === '/' || state.url === '/auth/login') {
                this.router.navigate(['/pages/shop/checkout']);
            }
            return true;
            } else {
            // 🔁 Redirect to maintenance page on failure
            this.router.navigate(['/others/error']);
            return false;
            }
        });
    }
}
